import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { TroubleshootingFunnelApi } from '@openx/types/troubleshootingFunnel';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue';
import { useTranslation } from 'react-i18next';
import { calculatePercentageValues } from '../utils/calculatePercentageValues';

export const FunnelEligibleBidRequests = ({ data }: { data: TroubleshootingFunnelApi }) => {
  const { discardedPercentage, discardedValueNumeric } = calculatePercentageValues(
    Number(data.eligible_bid_requests),
    Number(data.targeted_bid_requests)
  );
  const { t } = useTranslation();
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: theme => theme.spacing(0.5) }}
      data-test="funnel-elligible-bid-requests"
    >
      <Typography variant="body1" data-test="funnel-elligible-bid-requests-title">
        {t('The funnel contains data based on requests narrowed by chosen targeting filters.')}
      </Typography>
      <Tooltip
        placement="top"
        title={t(
          `Requests not targeted by your deal: ${abbreviateNumericValue(discardedValueNumeric, { allowZero: true })} (${discardedPercentage})`
        )}
        slotProps={{
          tooltip: {
            sx: {
              width: '178px',
            },
          },
        }}
      >
        <IconButton size="small" data-test="funnel-info-tooltip">
          <InfoRoundedIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
